import React from "react";

const Packages = () => {
  return (
    <div>
      <h1>Packages</h1>
    </div>
  );
};

export default Packages;
